const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="section-content has-text-right {~HideBottomEntryControls:Record~}" data-recordset-controls="add-set">
						{~EntryModeToggleButton:Record~}
						<button class="button is-link"
							id="RECORDSET-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
							data-max-sets="{~D:Record.MaximumRowCount~}"
							data-min-sets="{~D:Record.MinimumRowCount~}"
							type="button"
							onclick="_Pict.providers['Bulma-RecordSetControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}');"
						>
							<span class="icon">
								<i class="fas fa-plus"></i>
							</span>
							<span>Add new set</span>
						</button>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			// Scroll anchor for "Finish and go to Record". Row-ExtraPrefix is the only
			// slot rendered against the {Value, Key, Group} row record, so it is the
			// only place Record.Key / Record.Group resolve.
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->
						<span class="recordset-entry-anchor is-sr-only" data-recordset-group-index="{~D:Record.Group~}" data-recordset-row-index="{~D:Record.Key~}"></span>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
			<div class="PictSectionForm-RecordSet-Controls buttons is-right {~HideRecordSetControls:Record~}" data-recordset-controls="manage-set">
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('Delete', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-trash"></i>
					</span>
					<span>Delete</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveUp', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-up"></i>
					</span>
					<span>Up</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveDown', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-down"></i>
					</span>
					<span>Down</span>
				</a>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
							<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content"  style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
